import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from './AuthService';
import './Login.css';
import monkeyLogo from '../assets/Monito 512 x 512.png';

const Login = () => {
  const [mail, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await login(mail, btoa(password));
      const idv = localStorage.getItem('id_vendedor');
      if (!idv) {
        setError('Usuario no tiene ID de vendedor asignado');
        return;
      }
      navigate('/dashboard');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-hero">
          <img src={monkeyLogo} alt="MonkeyPhone" className="login-hero-img" />
          <h1>Bienvenido</h1>
          <p>Inicia sesión en tu cuenta de vendedor</p>
        </div>
        <form onSubmit={handleLogin} className="login-form">
          {error && <div className="login-error">{error}</div>}
          <input
            className="login-input"
            type="text"
            value={mail}
            placeholder="Usuario"
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <input
            className="login-input"
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button className="login-btn" type="submit">Iniciar Sesión</button>
        </form>
      </div>
    </div>
  );
};

export default Login;
